'use strict';
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var SqlString = require('sqlstring');
var _a = require('../../expr'), findExpr = _a.findExpr, walkExpr = _a.walkExpr;
var _b = require('../../expr_formatter'), formatExpr = _b.formatExpr, formatConditions = _b.formatConditions, collectLiteral = _b.collectLiteral, isAggregatorExpr = _b.isAggregatorExpr;
var Raw = require('../../raw').default;
/**
 * Make sure columns are qualified
 */
function qualify(spell) {
    var e_1, _a, e_2, _b;
    var Model = spell.Model, columns = spell.columns, groups = spell.groups, whereConditions = spell.whereConditions, havingConditions = spell.havingConditions, orders = spell.orders;
    var baseName = Model.tableAlias;
    var clarify = function (node) {
        if (node.type === 'id' && !node.qualifiers) {
            if (Model.columnAttributes[node.value])
                node.qualifiers = [baseName];
        }
    };
    try {
        for (var _c = __values(columns.concat(groups, whereConditions, havingConditions)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var ast = _d.value;
            walkExpr(ast, clarify);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var orders_1 = __values(orders), orders_1_1 = orders_1.next(); !orders_1_1.done; orders_1_1 = orders_1.next()) {
            var _e = __read(orders_1_1.value, 1), ast = _e[0];
            walkExpr(ast, clarify);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (orders_1_1 && !orders_1_1.done && (_b = orders_1.return)) _b.call(orders_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
}
/**
 * Format select list that indicates which columns to retrieve
 * @param {Spell} spell
 */
function formatSelectExpr(spell, values) {
    var e_3, _a, e_4, _b, e_5, _c, e_6, _d;
    var Model = spell.Model, columns = spell.columns, joins = spell.joins, groups = spell.groups;
    var escapeId = Model.driver.escapeId;
    var baseName = Model.tableAlias;
    var selects = new Set();
    var map = {};
    var isAggregate = false;
    try {
        for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
            var token = columns_1_1.value;
            collectLiteral(spell, token, values);
            var selectExpr = formatExpr(spell, token);
            isAggregate = isAggregate || isAggregatorExpr(spell, token);
            var qualifier = token.qualifiers ? token.qualifiers[0] : '';
            var list = map[qualifier] || (map[qualifier] = []);
            list.push(selectExpr);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    try {
        for (var _e = __values([baseName].concat(Object.keys(joins))), _f = _e.next(); !_f.done; _f = _e.next()) {
            var qualifier = _f.value;
            var list = map[qualifier];
            if (list) {
                try {
                    for (var list_1 = (e_5 = void 0, __values(list)), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()) {
                        var selectExpr = list_1_1.value;
                        selects.add(selectExpr);
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (list_1_1 && !list_1_1.done && (_c = list_1.return)) _c.call(list_1);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
            else if (groups.length === 0 && !['sqlite', 'sqljs'].includes(Model.driver.type) && !isAggregate) {
                selects.add("".concat(escapeId(qualifier), ".*"));
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_4) throw e_4.error; }
    }
    if (map['']) {
        try {
            for (var _g = __values(map['']), _h = _g.next(); !_h.done; _h = _g.next()) {
                var selectExpr = _h.value;
                selects.add(selectExpr);
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_d = _g.return)) _d.call(_g);
            }
            finally { if (e_6) throw e_6.error; }
        }
    }
    return Array.from(selects);
}
var SpellBook = /** @class */ (function () {
    function SpellBook() {
    }
    SpellBook.prototype.format = function (spell) {
        var e_7, _a;
        try {
            for (var _b = __values(spell.scopes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var scope = _c.value;
                scope(spell);
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_7) throw e_7.error; }
        }
        switch (spell.command) {
            case 'insert':
            case 'bulkInsert':
                return this.formatInsert(spell);
            case 'select':
                return this.formatSelect(spell);
            case 'update':
                return this.formatUpdate(spell);
            case 'delete':
                return this.formatDelete(spell);
            case 'upsert':
                return this.formatUpsert(spell);
            default:
                throw new Error("Unsupported SQL command ".concat(spell.command));
        }
    };
    /**
     * @abstract
     * @returns {string} optimizer hints
     */
    SpellBook.prototype.formatOptimizerHints = function () {
        return '';
    };
    /**
     * @abstract
     * @returns {string} index hints
     */
    SpellBook.prototype.formatIndexHints = function () {
        return '';
    };
    /**
    * Format a spell into INSERT query.
    * @param {Spell} spell
    */
    SpellBook.prototype.formatInsert = function (spell) {
        var e_8, _a, e_9, _b, e_10, _c;
        var Model = spell.Model, sets = spell.sets, optAttrs = spell.columnAttributes, updateOnDuplicate = spell.updateOnDuplicate;
        var shardingKey = Model.shardingKey;
        var createdAt = Model.timestamps.createdAt;
        var escapeId = Model.driver.escapeId;
        var columns = [];
        var updateOnDuplicateColumns = [];
        var values = [];
        var placeholders = [];
        if (Array.isArray(sets)) {
            // merge records to get the big picture of involved columnAttributes
            var involved = sets.reduce(function (result, entry) {
                return Object.assign(result, entry);
            }, {});
            var columnAttributes = [];
            if (optAttrs) {
                for (var name_1 in optAttrs) {
                    if (involved.hasOwnProperty(name_1))
                        columnAttributes.push(columnAttributes[name_1]);
                }
            }
            else {
                for (var name_2 in involved) {
                    columnAttributes.push(Model.columnAttributes[name_2]);
                }
            }
            try {
                for (var columnAttributes_1 = __values(columnAttributes), columnAttributes_1_1 = columnAttributes_1.next(); !columnAttributes_1_1.done; columnAttributes_1_1 = columnAttributes_1.next()) {
                    var entry = columnAttributes_1_1.value;
                    columns.push(entry.columnName);
                    if (updateOnDuplicate && createdAt && entry.name === createdAt
                        && !(Array.isArray(updateOnDuplicate) && updateOnDuplicate.includes(createdAt)))
                        continue;
                    updateOnDuplicateColumns.push(entry.columnName);
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (columnAttributes_1_1 && !columnAttributes_1_1.done && (_a = columnAttributes_1.return)) _a.call(columnAttributes_1);
                }
                finally { if (e_8) throw e_8.error; }
            }
            try {
                for (var sets_1 = __values(sets), sets_1_1 = sets_1.next(); !sets_1_1.done; sets_1_1 = sets_1.next()) {
                    var entry = sets_1_1.value;
                    if (shardingKey && entry[shardingKey] == null) {
                        throw new Error("Sharding key ".concat(Model.table, ".").concat(shardingKey, " cannot be NULL."));
                    }
                    try {
                        for (var columnAttributes_2 = (e_10 = void 0, __values(columnAttributes)), columnAttributes_2_1 = columnAttributes_2.next(); !columnAttributes_2_1.done; columnAttributes_2_1 = columnAttributes_2.next()) {
                            var attribute = columnAttributes_2_1.value;
                            var name_3 = attribute.name;
                            values.push(entry[name_3]);
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (columnAttributes_2_1 && !columnAttributes_2_1.done && (_c = columnAttributes_2.return)) _c.call(columnAttributes_2);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                    placeholders.push("(".concat(new Array(columnAttributes.length).fill('?').join(','), ")"));
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (sets_1_1 && !sets_1_1.done && (_b = sets_1.return)) _b.call(sets_1);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        else {
            if (shardingKey && sets[shardingKey] == null) {
                throw new Error("Sharding key ".concat(Model.table, ".").concat(shardingKey, " cannot be NULL."));
            }
            for (var name_4 in sets) {
                var value = sets[name_4];
                columns.push(Model.unalias(name_4));
                if (value instanceof Raw) {
                    values.push(SqlString.raw(value.value));
                }
                else {
                    values.push(value);
                }
                if (updateOnDuplicate && createdAt && name_4 === createdAt)
                    continue;
                updateOnDuplicateColumns.push(Model.unalias(name_4));
            }
        }
        var chunks = ['INSERT'];
        // see https://dev.mysql.com/doc/refman/8.0/en/optimizer-hints.html
        var hintStr = this.formatOptimizerHints(spell);
        if (hintStr) {
            chunks.push(hintStr);
        }
        chunks.push("INTO ".concat(escapeId(Model.table), " (").concat(columns.map(function (column) { return escapeId(column); }).join(', '), ")"));
        if (placeholders.length) {
            chunks.push("VALUES ".concat(placeholders.join(', ')));
        }
        else {
            chunks.push("VALUES (".concat(columns.map(function (_) { return '?'; }).join(', '), ")"));
        }
        chunks.push(this.formatUpdateOnDuplicate(spell, updateOnDuplicateColumns));
        chunks.push(this.formatReturning(spell));
        return {
            sql: chunks.join(' ').trim(),
            values: values,
        };
    };
    /**
     * Format a spell without joins into a full SELECT query. This function is also used to format the subquery which is then used as a drived table in a SELECT with joins.
     * @param {Spell} spell
     */
    SpellBook.prototype.formatSelectWithoutJoin = function (spell) {
        var e_11, _a, e_12, _b, e_13, _c, e_14, _d, e_15, _e;
        var columns = spell.columns, whereConditions = spell.whereConditions, groups = spell.groups, havingConditions = spell.havingConditions, orders = spell.orders, rowCount = spell.rowCount, skip = spell.skip, Model = spell.Model;
        var escapeId = Model.driver.escapeId;
        var chunks = ['SELECT'];
        var values = [];
        // see https://dev.mysql.com/doc/refman/8.0/en/optimizer-hints.html
        var hintStr = this.formatOptimizerHints(spell);
        if (hintStr) {
            chunks.push(hintStr);
        }
        if (columns.length > 0) {
            try {
                for (var columns_2 = __values(columns), columns_2_1 = columns_2.next(); !columns_2_1.done; columns_2_1 = columns_2.next()) {
                    var column = columns_2_1.value;
                    collectLiteral(spell, column, values);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (columns_2_1 && !columns_2_1.done && (_a = columns_2.return)) _a.call(columns_2);
                }
                finally { if (e_11) throw e_11.error; }
            }
            var selects = [];
            try {
                for (var columns_3 = __values(columns), columns_3_1 = columns_3.next(); !columns_3_1.done; columns_3_1 = columns_3.next()) {
                    var token = columns_3_1.value;
                    var column = formatExpr(spell, token);
                    if (!selects.includes(column))
                        selects.push(column);
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (columns_3_1 && !columns_3_1.done && (_b = columns_3.return)) _b.call(columns_3);
                }
                finally { if (e_12) throw e_12.error; }
            }
            chunks.push("".concat(selects.join(', ')));
        }
        else {
            chunks.push('*');
        }
        var table = formatExpr(spell, spell.table);
        chunks.push("FROM ".concat(table));
        if (spell.table.value instanceof spell.constructor) {
            var subTableAlias = spell.table.value.Model && spell.table.value.Model.tableAlias;
            chunks.push("AS ".concat(subTableAlias ? escapeId(subTableAlias) : "t".concat(spell.subqueryIndex++)));
        }
        // see https://dev.mysql.com/doc/refman/8.0/en/index-hints.html
        var indexHintStr = this.formatIndexHints(spell);
        if (indexHintStr) {
            chunks.push(indexHintStr);
        }
        if (whereConditions.length > 0) {
            try {
                for (var whereConditions_1 = __values(whereConditions), whereConditions_1_1 = whereConditions_1.next(); !whereConditions_1_1.done; whereConditions_1_1 = whereConditions_1.next()) {
                    var condition = whereConditions_1_1.value;
                    collectLiteral(spell, condition, values);
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (whereConditions_1_1 && !whereConditions_1_1.done && (_c = whereConditions_1.return)) _c.call(whereConditions_1);
                }
                finally { if (e_13) throw e_13.error; }
            }
            chunks.push("WHERE ".concat(formatConditions(spell, whereConditions)));
        }
        if (groups.length > 0) {
            var groupColumns = groups.map(function (group) { return formatExpr(spell, group); });
            chunks.push("GROUP BY ".concat(groupColumns.join(', ')));
        }
        if (havingConditions.length > 0) {
            try {
                for (var havingConditions_1 = __values(havingConditions), havingConditions_1_1 = havingConditions_1.next(); !havingConditions_1_1.done; havingConditions_1_1 = havingConditions_1.next()) {
                    var condition = havingConditions_1_1.value;
                    collectLiteral(spell, condition, values);
                }
            }
            catch (e_14_1) { e_14 = { error: e_14_1 }; }
            finally {
                try {
                    if (havingConditions_1_1 && !havingConditions_1_1.done && (_d = havingConditions_1.return)) _d.call(havingConditions_1);
                }
                finally { if (e_14) throw e_14.error; }
            }
            chunks.push("HAVING ".concat(formatConditions(spell, havingConditions)));
        }
        if (orders.length > 0) {
            try {
                // ORDER BY FIND_IN_SET(`id`, '1,2,3')
                for (var orders_2 = __values(orders), orders_2_1 = orders_2.next(); !orders_2_1.done; orders_2_1 = orders_2.next()) {
                    var _f = __read(orders_2_1.value, 1), expr = _f[0];
                    collectLiteral(spell, expr, values);
                }
            }
            catch (e_15_1) { e_15 = { error: e_15_1 }; }
            finally {
                try {
                    if (orders_2_1 && !orders_2_1.done && (_e = orders_2.return)) _e.call(orders_2);
                }
                finally { if (e_15) throw e_15.error; }
            }
            chunks.push("ORDER BY ".concat(this.formatOrders(spell, orders).join(', ')));
        }
        if (rowCount > 0)
            chunks.push("LIMIT ".concat(rowCount));
        if (skip > 0)
            chunks.push("OFFSET ".concat(skip));
        return { sql: chunks.join(' '), values: values };
    };
    /**
     * INSERT ... ON CONFLICT ... UPDATE SET
     * - https://www.postgresql.org/docs/9.5/sql-insert.html
     * - https://www.sqlite.org/lang_UPSERT.html
     * @param {Spell} spell
     */
    SpellBook.prototype.formatUpsert = function (spell) {
        if (!spell.updateOnDuplicate) {
            spell.updateOnDuplicate = true;
        }
        var _a = this.formatInsert(spell), sql = _a.sql, values = _a.values;
        return {
            sql: sql,
            values: values,
        };
    };
    /**
     * @param {Spell} spell
     * @returns returning sql string
     */
    SpellBook.prototype.formatReturning = function (spell) {
        var Model = spell.Model, returning = spell.returning;
        var primaryColumn = Model.primaryColumn;
        var escapeId = Model.driver.escapeId;
        var returnings;
        if (returning === true)
            returnings = [escapeId(primaryColumn)];
        if (Array.isArray(returning)) {
            returnings = returning.map(escapeId);
        }
        return returnings && returnings.length ? "RETURNING ".concat(returnings.join(', ')) : '';
    };
    /**
     * @param {Spell} spell
     * @param {Array} columns columns for value set
     */
    SpellBook.prototype.formatUpdateOnDuplicate = function (spell, columns) {
        var e_16, _a;
        var updateOnDuplicate = spell.updateOnDuplicate, uniqueKeys = spell.uniqueKeys, Model = spell.Model, sets = spell.sets;
        if (!updateOnDuplicate)
            return '';
        var columnAttributes = Model.columnAttributes, primaryColumn = Model.primaryColumn;
        var escapeId = Model.driver.escapeId;
        var actualUniqueKeys = [];
        if (uniqueKeys) {
            try {
                for (var _b = __values([].concat(uniqueKeys)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var field = _c.value;
                    actualUniqueKeys.push(escapeId(field));
                }
            }
            catch (e_16_1) { e_16 = { error: e_16_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_16) throw e_16.error; }
            }
        }
        else {
            var setFields = Object.keys(sets);
            // conflict_target must be unique
            // get all unique keys
            if (columnAttributes) {
                for (var key in columnAttributes) {
                    var att = columnAttributes[key];
                    // use the first unique key
                    if (att.unique || (att.primaryKey && setFields.includes(att.name))) {
                        actualUniqueKeys.push(escapeId(att.columnName));
                        break;
                    }
                }
            }
            if (!actualUniqueKeys.length)
                actualUniqueKeys.push(escapeId(primaryColumn));
            // default use id as primary key
            if (!actualUniqueKeys.length)
                actualUniqueKeys.push(escapeId('id'));
        }
        if (Array.isArray(updateOnDuplicate) && updateOnDuplicate.length) {
            columns = updateOnDuplicate.map(function (column) { return (columnAttributes[column] && columnAttributes[column].columnName) || column; });
        }
        else if (!columns.length) {
            columns = Object.values(columnAttributes).map(function (_a) {
                var columnName = _a.columnName;
                return columnName;
            });
        }
        var updateKeys = columns.map(function (column) { return "".concat(escapeId(column), "=EXCLUDED.").concat(escapeId(column)); });
        return "ON CONFLICT (".concat(actualUniqueKeys.join(', '), ") DO UPDATE SET ").concat(updateKeys.join(', '));
    };
    /**
     * Format a spell into UPDATE query
     * @param {Spell} spell
     */
    SpellBook.prototype.formatUpdate = function (spell) {
        var e_17, _a;
        var Model = spell.Model, sets = spell.sets, whereConditions = spell.whereConditions;
        var shardingKey = Model.shardingKey;
        if (shardingKey) {
            if (sets.hasOwnProperty(shardingKey) && sets[shardingKey] == null) {
                throw new Error("Sharding key ".concat(Model.table, ".").concat(shardingKey, " cannot be NULL"));
            }
            if (!whereConditions.some(function (condition) { return findExpr(condition, { type: 'id', value: shardingKey }); })) {
                throw new Error("Sharding key ".concat(Model.table, ".").concat(shardingKey, " is required."));
            }
        }
        if (Object.keys(sets).length === 0) {
            throw new Error('Unable to update with empty set');
        }
        var chunks = ['UPDATE'];
        var values = [];
        var assigns = [];
        var escapeId = Model.driver.escapeId;
        for (var name_5 in sets) {
            var value = sets[name_5];
            if (value && value.__expr) {
                assigns.push("".concat(escapeId(Model.unalias(name_5)), " = ").concat(formatExpr(spell, value)));
                collectLiteral(spell, value, values);
            }
            else if (value instanceof Raw) {
                assigns.push("".concat(escapeId(Model.unalias(name_5)), " = ").concat(value.value));
            }
            else {
                assigns.push("".concat(escapeId(Model.unalias(name_5)), " = ?"));
                values.push(sets[name_5]);
            }
        }
        // see https://dev.mysql.com/doc/refman/8.0/en/optimizer-hints.html
        var hintStr = this.formatOptimizerHints(spell);
        // see https://dev.mysql.com/doc/refman/8.0/en/index-hints.html
        var indexHintStr = this.formatIndexHints(spell);
        if (hintStr) {
            chunks.push(hintStr);
        }
        chunks.push(escapeId(Model.table));
        if (indexHintStr) {
            chunks.push(indexHintStr);
        }
        chunks.push("SET ".concat(assigns.join(', ')));
        if (whereConditions.length > 0) {
            try {
                for (var whereConditions_2 = __values(whereConditions), whereConditions_2_1 = whereConditions_2.next(); !whereConditions_2_1.done; whereConditions_2_1 = whereConditions_2.next()) {
                    var condition = whereConditions_2_1.value;
                    collectLiteral(spell, condition, values);
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (whereConditions_2_1 && !whereConditions_2_1.done && (_a = whereConditions_2.return)) _a.call(whereConditions_2);
                }
                finally { if (e_17) throw e_17.error; }
            }
            chunks.push("WHERE ".concat(formatConditions(spell, whereConditions)));
        }
        return {
            sql: chunks.join(' '),
            values: values,
        };
    };
    /**
     * Format the spell into a DELETE query.
     * @param {Spell} spell
     */
    SpellBook.prototype.formatDelete = function (spell) {
        var e_18, _a;
        var Model = spell.Model, whereConditions = spell.whereConditions;
        var shardingKey = Model.shardingKey;
        var escapeId = Model.driver.escapeId;
        var table = escapeId(Model.table);
        if (shardingKey && !whereConditions.some(function (condition) { return findExpr(condition, { type: 'id', value: shardingKey }); })) {
            throw new Error("Sharding key ".concat(Model.table, ".").concat(shardingKey, " is required."));
        }
        var chunks = ['DELETE'];
        // see https://dev.mysql.com/doc/refman/8.0/en/optimizer-hints.html
        var hintStr = this.formatOptimizerHints(spell);
        if (hintStr) {
            chunks.push(hintStr);
        }
        chunks.push("FROM ".concat(table));
        if (whereConditions.length > 0) {
            var values = [];
            try {
                for (var whereConditions_3 = __values(whereConditions), whereConditions_3_1 = whereConditions_3.next(); !whereConditions_3_1.done; whereConditions_3_1 = whereConditions_3.next()) {
                    var condition = whereConditions_3_1.value;
                    collectLiteral(spell, condition, values);
                }
            }
            catch (e_18_1) { e_18 = { error: e_18_1 }; }
            finally {
                try {
                    if (whereConditions_3_1 && !whereConditions_3_1.done && (_a = whereConditions_3.return)) _a.call(whereConditions_3);
                }
                finally { if (e_18) throw e_18.error; }
            }
            chunks.push("WHERE ".concat(formatConditions(spell, whereConditions)));
            return {
                sql: chunks.join(' '),
                values: values
            };
        }
        else {
            return { sql: chunks.join(' ') };
        }
    };
    /**
     * To help choosing the right function when formatting a spell into SELECT query.
     * @param {Spell} spell
     */
    SpellBook.prototype.formatSelect = function (spell) {
        var whereConditions = spell.whereConditions;
        var _a = spell.Model, shardingKey = _a.shardingKey, table = _a.table;
        if (shardingKey && !whereConditions.some(function (condition) { return findExpr(condition, { type: 'id', value: shardingKey }); })) {
            throw new Error("Sharding key ".concat(table, ".").concat(shardingKey, " is required."));
        }
        if (spell.skip > 0 && spell.rowCount == null) {
            throw new Error('Unable to query with OFFSET yet without LIMIT');
        }
        return Object.keys(spell.joins).length > 0
            ? this.formatSelectWithJoin(spell)
            : this.formatSelectWithoutJoin(spell);
    };
    /**
     * Format a spell with joins into a full SELECT query.
     * @param {Spell} spell
     */
    SpellBook.prototype.formatSelectWithJoin = function (spell) {
        var e_19, _a, e_20, _b;
        // Since it is a JOIN query, make sure columns are always qualified.
        qualify(spell);
        var Model = spell.Model, whereConditions = spell.whereConditions, groups = spell.groups, havingConditions = spell.havingConditions, orders = spell.orders, rowCount = spell.rowCount, skip = spell.skip, joins = spell.joins;
        var escapeId = Model.driver.escapeId;
        var baseName = Model.tableAlias;
        var chunks = ['SELECT'];
        var values = [];
        var selects = formatSelectExpr(spell, values);
        // see https://dev.mysql.com/doc/refman/8.0/en/optimizer-hints.html
        var hintStr = this.formatOptimizerHints(spell);
        if (hintStr) {
            chunks.push(hintStr);
        }
        chunks.push(selects.join(', '));
        var table = formatExpr(spell, spell.table);
        chunks.push("FROM ".concat(table));
        if (spell.table.value instanceof spell.constructor) {
            var subTableAlias = spell.table.value.Model && spell.table.value.Model.tableAlias;
            chunks.push("AS ".concat(subTableAlias ? escapeId(subTableAlias) : "t".concat(spell.subqueryIndex++)));
        }
        else {
            chunks.push("AS ".concat(escapeId(baseName)));
        }
        for (var qualifier in joins) {
            var _c = joins[qualifier], RefModel = _c.Model, on = _c.on;
            collectLiteral(spell, on, values);
            chunks.push("LEFT JOIN ".concat(escapeId(RefModel.table), " AS ").concat(escapeId(qualifier), " ON ").concat(formatExpr(spell, on)));
        }
        // see https://dev.mysql.com/doc/refman/8.0/en/index-hints.html
        var indexHintStr = this.formatIndexHints(spell);
        if (indexHintStr) {
            chunks.push(indexHintStr);
        }
        if (whereConditions.length > 0) {
            try {
                for (var whereConditions_4 = __values(whereConditions), whereConditions_4_1 = whereConditions_4.next(); !whereConditions_4_1.done; whereConditions_4_1 = whereConditions_4.next()) {
                    var condition = whereConditions_4_1.value;
                    collectLiteral(spell, condition, values);
                }
            }
            catch (e_19_1) { e_19 = { error: e_19_1 }; }
            finally {
                try {
                    if (whereConditions_4_1 && !whereConditions_4_1.done && (_a = whereConditions_4.return)) _a.call(whereConditions_4);
                }
                finally { if (e_19) throw e_19.error; }
            }
            chunks.push("WHERE ".concat(formatConditions(spell, whereConditions)));
        }
        if (groups.length > 0) {
            chunks.push("GROUP BY ".concat(groups.map(function (group) { return formatExpr(spell, group); }).join(', ')));
        }
        if (havingConditions.length > 0) {
            try {
                for (var havingConditions_2 = __values(havingConditions), havingConditions_2_1 = havingConditions_2.next(); !havingConditions_2_1.done; havingConditions_2_1 = havingConditions_2.next()) {
                    var condition = havingConditions_2_1.value;
                    collectLiteral(spell, condition, values);
                }
            }
            catch (e_20_1) { e_20 = { error: e_20_1 }; }
            finally {
                try {
                    if (havingConditions_2_1 && !havingConditions_2_1.done && (_b = havingConditions_2.return)) _b.call(havingConditions_2);
                }
                finally { if (e_20) throw e_20.error; }
            }
            chunks.push("HAVING ".concat(formatConditions(spell, havingConditions)));
        }
        if (orders.length > 0)
            chunks.push("ORDER BY ".concat(this.formatOrders(spell, orders).join(', ')));
        if (rowCount > 0)
            chunks.push("LIMIT ".concat(rowCount));
        if (skip > 0)
            chunks.push("OFFSET ".concat(skip));
        return { sql: chunks.join(' '), values: values };
    };
    /**
     * Format orders into ORDER BY clause in SQL
     * @param {Spell}    spell
     * @param {Object[]} orders
     */
    SpellBook.prototype.formatOrders = function (spell, orders) {
        return orders.map(function (_a) {
            var _b = __read(_a, 2), token = _b[0], order = _b[1];
            var column = formatExpr(spell, token);
            return order == 'desc' ? "".concat(column, " DESC") : column;
        });
    };
    return SpellBook;
}());
;
module.exports = SpellBook;
//# sourceMappingURL=spellbook.js.map